<div class="container">
  <div class="row justify-content-center">
    <div class="col-12 col-sm-8">

      <div *ngIf="hasSubscriptions" class="spacing spacing--sm">
        Your institution's current subscriptions are listed below. If any information appears incorrect or you would like to add subscriptions, please contact the AAOS Service Center at <a href="mailto:customerservice@aaos.org">customerservice@aaos.org</a> or 1-800-626-6726.
      </div>
      <div *ngIf="!hasSubscriptions" class="spacing spacing--sm">
        No subscriptions are currently associated with this institution. If you would like to add a subscription or believe this information is incorrect, please contact the AAOS Service Center at <a href="mailto:customerservice@aaos.org">customerservice@aaos.org</a> or 1-800-626-6726.
      </div>
      <div *ngIf="!loading">
        <aaos-subscriptions-table [subscriptions]="institutionSubscriptions">
        </aaos-subscriptions-table>
      </div>
    </div>
  </div>
</div>
<aaos-spinner [isLoading]="loading"></aaos-spinner>
